import { render, staticRenderFns } from "./Annotation.vue?vue&type=template&id=2fc15cf7&scoped=true&"
import script from "./Annotation.vue?vue&type=script&lang=js&"
export * from "./Annotation.vue?vue&type=script&lang=js&"
import style0 from "./Annotation.vue?vue&type=style&index=0&id=2fc15cf7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc15cf7",
  null
  
)

component.options.__file = "Annotation.vue"
export default component.exports